<route>
{
  "name": "dashboard",
  "meta": {
    "order": 2,
    "isVisible": false,
    "iconName": "mdi-book"
  }
}
</route>
<template>
  <div>
    <page-title
      :title="$t('pages.dashboard.title')"
    ></page-title>
    <v-card
      class="mx-2 my-2 float-right"
      >
      <v-list-item>
        <v-list-item-avatar color="grey"></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
          <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-img
        src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
        height="194"
        ></v-img>
      <v-card-text>
        Visit ten places on our planet that are undergoing the biggest changes today.
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="deep-purple accent-4"
          >
          Read
        </v-btn>
          <v-btn
            text
            color="deep-purple accent-4"
            >
            Bookmark
          </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-share-variant</v-icon>
            </v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      class="mx-2 my-2 float-right"
      >
      <v-list-item>
        <v-list-item-avatar color="grey"></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
          <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-img
        src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
        height="194"
        ></v-img>
      <v-card-text>
        Visit ten places on our planet that are undergoing the biggest changes today.
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="deep-purple accent-4"
          >
          Read
        </v-btn>
          <v-btn
            text
            color="deep-purple accent-4"
            >
            Bookmark
          </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-share-variant</v-icon>
            </v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      class="mx-2 my-2 float-right"
      >
      <v-list-item>
        <v-list-item-avatar color="grey"></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
          <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-img
        src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
        height="194"
        ></v-img>
      <v-card-text>
        Visit ten places on our planet that are undergoing the biggest changes today.
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="deep-purple accent-4"
          >
          Read
        </v-btn>
          <v-btn
            text
            color="deep-purple accent-4"
            >
            Bookmark
          </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-share-variant</v-icon>
            </v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      class="mx-2 my-2 float-right"
      >
      <v-list-item>
        <v-list-item-avatar color="grey"></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
          <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-img
        src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
        height="194"
        ></v-img>
      <v-card-text>
        Visit ten places on our planet that are undergoing the biggest changes today.
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="deep-purple accent-4"
          >
          Read
        </v-btn>
          <v-btn
            text
            color="deep-purple accent-4"
            >
            Bookmark
          </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-share-variant</v-icon>
            </v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      class="mx-2 my-2 float-right"
      >
      <v-list-item>
        <v-list-item-avatar color="grey"></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
          <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-img
        src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
        height="194"
        ></v-img>
      <v-card-text>
        Visit ten places on our planet that are undergoing the biggest changes today.
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="deep-purple accent-4"
          >
          Read
        </v-btn>
          <v-btn
            text
            color="deep-purple accent-4"
            >
            Bookmark
          </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-share-variant</v-icon>
            </v-btn>
      </v-card-actions>
    </v-card>
    <v-card
      class="mx-2 my-2 float-right"
      >
      <v-list-item>
        <v-list-item-avatar color="grey"></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">Our Changing Planet</v-list-item-title>
          <v-list-item-subtitle>by Kurt Wagner</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-img
        src="https://cdn.vuetifyjs.com/images/cards/mountain.jpg"
        height="194"
        ></v-img>
      <v-card-text>
        Visit ten places on our planet that are undergoing the biggest changes today.
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="deep-purple accent-4"
          >
          Read
        </v-btn>
          <v-btn
            text
            color="deep-purple accent-4"
            >
            Bookmark
          </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-share-variant</v-icon>
            </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
export default {
  layout: APP_CONFIG.layout.mainPanelLayout
}
</script>
